document.addEventListener("DOMContentLoaded", () => {
  let pinchZoomElements = document.querySelectorAll(".PinchZoomImageContainer img");

  pinchZoomElements.forEach((pinchZoomElement) => {
    hammerIt(pinchZoomElement);
  })

  function hammerIt(elm) {
    hammertime = new Hammer(elm, {});

    hammertime.get("pinch").set({
      enable: true,
    });

    var posX = 0,
      posY = 0,
      scale = 1,
      last_scale = 1,
      last_posX = 0,
      last_posY = 0,
      max_pos_x = 0,
      max_pos_y = 0,
      transform = "",
      el = elm;

    hammertime.on("pan pinch panend pinchend", function (ev) {
      //pan
      if (scale != 1) {
        posX = last_posX + ev.deltaX;
        posY = last_posY + ev.deltaY;
        max_pos_x = Math.ceil(((scale - 1) * el.clientWidth) / 2);
        max_pos_y = Math.ceil(((scale - 1) * el.clientHeight) / 2);

        if (posX > max_pos_x) {
          posX = max_pos_x;
        }
        if (posX < -max_pos_x) {
          posX = -max_pos_x;
        }
        if (posY > max_pos_y) {
          posY = max_pos_y;
        }
        if (posY < -max_pos_y) {
          posY = -max_pos_y;
        }
      }

      //pinch
      if (ev.type == "pinch") {
        scale = Math.max(0.999, Math.min(last_scale * ev.scale, 4));
      }

      if (ev.type == "pinchend") {
        last_scale = scale;
      }

      //panend
      if (ev.type == "panend") {
        last_posX = posX < max_pos_x ? posX : max_pos_x;
        last_posY = posY < max_pos_y ? posY : max_pos_y;
      }

      if (scale != 1) {
        transform = "translate3d(" + posX + "px," + posY + "px, 0) " + "scale3d(" + scale + ", " + scale + ", 1)";
      }

      if (transform) {
        el.style.webkitTransform = transform;
      }
    });
  }
});


// This script to manage data flow from Paperform form submissions to GTM.
window.addEventListener("message", (event) => {
  if (typeof event.data != "string" ||
    !event.data.startsWith("paperform:")
  )
    return;

  try {
    decodedData = JSON.parse(event.data.substring(10));
  } catch (e) {
    return;
  }

  if (
    !decodedData.hasOwnProperty("action") ||
    decodedData.action != "submission"
  )
    return;

  window.dataLayer.push({
    event: "request_form_submitted",
    formLocation: window.location.pathname,
  });
});

(function() {
  // Function to save the scroll position
  function saveScrollPosition() {
    history.replaceState({ scrollY: window.scrollY }, '');
  }

  // Function to restore the scroll position
  function restoreScrollPosition(event) {
    if (event.state && typeof event.state.scrollY === 'number') {
      setTimeout(() => {
        window.scrollTo({
          top: event.state.scrollY,
          behavior: 'smooth'
        });
      }, 1000);
    }
  }

  // Save the scroll position before navigating away
  window.addEventListener('scroll', saveScrollPosition);

  // Restore the scroll position when navigating back
  window.addEventListener('popstate', restoreScrollPosition);

  // Optionally restore on page load
  restoreScrollPosition({ state: history.state });
})();

// Desktop Search Type-ahead
(function() {
  var searchInput = document.querySelector('.Search__Input--v2[name="q"]');
  var searchElement = document.getElementById('Search');
  var searchResultsElement = searchElement ? searchElement.querySelector('.Search__Results') : null;
  var searchInner = document.querySelector('.Search__Inner');
  var searchFormV1 = document.querySelector('.Search__Form--v1');
  var pageOverlay = document.querySelector('.PageOverlay');
  var lastInputValue = '';
  var debounceTimer = null;

  if (!searchInput || !searchElement || !searchResultsElement) return;

  function debounce(fn, delay) {
    return function() {
      var args = arguments;
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function() {
        fn.apply(null, args);
      }, delay);
    };
  }

  function resetSearch() {
    searchResultsElement.innerHTML = '';
    searchResultsElement.setAttribute('aria-hidden', 'true');
    // Reset visibility of legacy search form
    if (searchFormV1 && searchFormV1.style.visibility === 'hidden') {
      searchFormV1.style.visibility = 'visible';
    }
  }

  function closeSearch() {
    searchElement.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    if (pageOverlay) pageOverlay.classList.remove('is-visible');
    var headerSection = document.querySelector('#shopify-section-header');
    if (headerSection) headerSection.style.zIndex = '';
    resetSearch();
  }

  var onInput = debounce(function(e) {
    var value = e.target.value;
    lastInputValue = value;

    if (!value || value.trim() === '') {
      closeSearch();
      return;
    }

    var searchMode = (window.theme && window.theme.searchMode) ? window.theme.searchMode : 'product';
    var queries = [
      fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(value) + '*&type=product', {
        method: 'GET',
        credentials: 'same-origin'
      })
    ];

    // Add articles/pages query if search mode includes them
    if (searchMode !== 'product') {
      queries.push(
        fetch(window.routes.searchUrl + '?view=ajax&q=' + encodeURIComponent(value) + '*&type=' + searchMode.replace('product,', ''), {
          method: 'GET',
          credentials: 'same-origin'
        })
      );
    }

    Promise.all(queries)
    .then(function(responses) {
      return Promise.all(responses.map(function(r) { return r.text(); }));
    })
    .then(function(contents) {
      if (lastInputValue !== value) return;

      // Desktop: show Search__Inner but hide the form (keep close button visible)
      if (window.innerWidth >= 1140) {
        if (searchInner) {
          searchInner.style.display = 'block';
          searchInner.style.visibility = 'visible';
        }
        if (searchFormV1) {
          searchFormV1.style.visibility = 'hidden';
        }
      }

      if (pageOverlay) pageOverlay.classList.add('is-visible');
      var headerSection = document.querySelector('#shopify-section-header');
      if (headerSection) headerSection.style.zIndex = 10;

      // Show products + articles/pages if available
      if (searchMode === 'product') {
        searchResultsElement.innerHTML = contents[0];
      } else {
        searchResultsElement.innerHTML = '<div class="PageLayout PageLayout--breakLap">' +
          '<div class="PageLayout__Section">' + contents[0] + '</div>' +
          '<div class="PageLayout__Section PageLayout__Section--secondary">' + contents[1] + '</div>' +
        '</div>';
      }

      searchElement.setAttribute('aria-hidden', 'false');
      searchResultsElement.setAttribute('aria-hidden', 'false');
    });
  }, 250);

  searchInput.addEventListener('input', onInput);

  // Close on overlay click
  if (pageOverlay) {
    pageOverlay.addEventListener('click', closeSearch);
  }

  // Close button
  document.body.addEventListener('click', function(e) {
    if (e.target.closest('[data-action="close-search"]')) {
      closeSearch();
    }
  });
})();